import React from "react";
import Logo from "@/components/Logo";
import { useLang } from "@/i18n";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-slate-100 mt-24 bg-white">
      <div className="tsw-section py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="space-y-3">
          <Logo />
          <p className="text-sm text-slate-500 max-w-md">{t("landing.footerNote")}</p>
        </div>
        <div className="text-xs text-slate-500">
          © {new Date().getFullYear()} {t("common.brand")} · {t("common.managedBy")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
